'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'sailboat';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e445';
var svgPathData = ['M66.1 328.1l128-224c3.6-6.3 11-9.4 18-7.5s11.9 8.2 11.9 15.5l0 224c0 8.8-7.2 16-16 16L80 352c-5.7 0-11-3-13.8-8s-2.9-11-.1-16zM256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c1.9 2.7 2.9 6 2.9 9.2c0 2.5-.6 5.1-1.8 7.4c-2.8 5.3-8.2 8.6-14.2 8.6l-224 0c-8.8 0-16-7.2-16-16l0-320z', 'M5.7 404.3C2.8 394.1 10.5 384 21.1 384H554.9c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSailboat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;